import { t } from 'i18next';

export const addLocationInputFields: {
  label: string;
  errorMsg: string[] | undefined;
  name: string;
  type: string;
  icon: string;
  className: string;
  onChange: () => void;
}[] = [
  {
    label: 'Name',
    errorMsg: undefined,
    name: 'name',
    type: 'text',
    icon: 'bi bi-tag-fill',
    className: 'name',
    onChange: () => {},
  },
  {
    label: 'adress',
    errorMsg: undefined,
    name: 'address',
    type: 'text',
    icon: 'bi bi-house-door-fill',
    className: 'address',
    onChange: () => {},
  },
];

export const addLocationSubmitButton = [
  {
    text: t('input_fields.button_submit'),
    className: 'btn btn-primary w-100',
    icon: '',
    onClick: (e: any) => {},
  },
];
